module.exports = __webpack_public_path__ + "assets/img/42.8cec9ae1.png";